import React, { useState } from 'react';

function GenerateWordPage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [showSampleFormat, setShowSampleFormat] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setError(null);
    setUploadSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedFile) {
      setError('Please select a file to upload');
      return;
    }

    setIsLoading(true);
    setError(null);
    setUploadSuccess(false);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      // Call the Azure Function to generate Word document
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${apiBaseUrl}/api/survey/generateWord`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      // Get the file from the response
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary link and trigger download
      const a = document.createElement('a');
      a.href = url;
      a.download = selectedFile.name.replace(/\.[^/.]+$/, '') + '.docx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      
      setUploadSuccess(true);
    } catch (err) {
      setError(err.message);
      console.error('Error generating Word document:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleSampleFormat = () => {
    setShowSampleFormat(!showSampleFormat);
  };

  const sampleSurveyFormat = `--------------------
~S1
.title Introduction Section
.template standard

.qt
Welcome to our survey. Please answer the following questions.
*) Continue
--------------------
~Q1
.title First Question
.template question

.qt
How satisfied are you with our service?
*) Very satisfied
*) Satisfied
*) Neutral
*) Dissatisfied
*) Very dissatisfied
--------------------
~Q2
.title Open-Ended Question
.template open

.qt
Please provide any additional feedback or suggestions:
*) ?? (Open-ended response)
--------------------`;

  return (
    <div>
      <h1>Generate Word Document</h1>
      <p>
        Upload a text file to generate a formatted Word document.
      </p>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label 
              htmlFor="fileUpload" 
              style={{ 
                display: 'block', 
                marginBottom: '10px',
                fontWeight: 'bold',
                textAlign: 'left'
              }}
            >
              Select File:
            </label>
            <input
              id="fileUpload"
              type="file"
              accept=".txt"
              onChange={handleFileChange}
              style={{ 
                display: 'block',
                width: '100%',
                padding: '10px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                color: '#333',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
            />
            <p style={{ 
              fontSize: '14px', 
              marginTop: '5px', 
              color: '#aaa',
              textAlign: 'left'
            }}>
              Upload a text file (.txt) containing survey data
              <button 
                type="button" 
                onClick={toggleSampleFormat}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#61dafb',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: '0 5px',
                  fontSize: '14px'
                }}
              >
                {showSampleFormat ? 'Hide Sample' : 'View Sample Format'}
              </button>
            </p>
            
            {showSampleFormat && (
              <div style={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                padding: '15px',
                borderRadius: '4px',
                marginTop: '10px',
                textAlign: 'left',
                fontFamily: 'monospace',
                fontSize: '14px',
                whiteSpace: 'pre-wrap',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {sampleSurveyFormat}
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={isLoading || !selectedFile}
            className="btn-primary"
            style={{
              width: '100%',
              opacity: isLoading || !selectedFile ? 0.7 : 1,
              cursor: isLoading || !selectedFile ? 'not-allowed' : 'pointer'
            }}
          >
            {isLoading ? 'Generating Document...' : 'Generate Word Document'}
          </button>
        </form>
      </div>
      
      {error && (
        <div className="alert alert-error">
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {uploadSuccess && (
        <div className="alert alert-success">
          <strong>Success!</strong> Your Word document has been generated and downloaded.
        </div>
      )}
    </div>
  );
}

export default GenerateWordPage;